import { CatHeading } from '@blocks-react/components/Heading';
import { FirstAvailableProp } from '../types';

export const RequestServiceFirstAvailable = ({
  children,
  imgProp,
  classname
}: FirstAvailableProp) => {
  return (
    <div className={classname}>
      <figure className="mb-0">
        <img
          src={`${imgProp.src}${imgProp.size}`}
          alt={imgProp.alt}
          loading="lazy"
        />
      </figure>
      <CatHeading variant="body-sm">{children}</CatHeading>
    </div>
  );
};
